import { Col, Row } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getCourseraContents } from "../../slices/courseraSlice";
import { ClockIcon, LocationIcon } from "../../utils/icons";
import LoadingCom from "../LoadingCom";
function TypeOfCourses({
  setResData,
  courseData,
  title,
  loadMore,
  total,
  setLoading,
  loading,
  courseSearch,
}) {
  console.log(":rocket: ~ TypeOfCourses ~ total:", total);
  console.log(":rocket: ~ TypeOfCourses ~ courseData:", courseData?.length);
  const cond = total > courseData?.length;
  console.log(":rocket: ~ cond:", cond);
  const navigate = useNavigate();
  const [loadingMore, setLoadingMore] = useState(false);
  console.log(":rocket: ~ TypeOfCourses ~ loadingMore:", loadingMore);
  const dispatch = useDispatch();
  const [start, setStart] = useState(0);
  const [limit, setLimit] = useState(10);
  console.log("start:", start, limit);
  console.log(loading, "loadinggggggg");
  console.log(courseData, "courseData");
  // console.log("limit:", limit);
  const observerTarget = useRef(null);
  useEffect(() => {
    if (!courseSearch) {
      const observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && !loadingMore && cond) {
            // setLimit((prevLimit) => prevLimit + 10);
            setStart((prevStart) => prevStart + 10);
            setLoadingMore(true);
            setLoading(true);
            dispatch(getCourseraContents({ start: start, limit: limit })).then(
              (res) => {
                const data = res?.payload?.data?.elements;
                const newData = start === 0 ? data : courseData.concat(data);
                setResData(newData);
                setLoading(false);
                setLoadingMore(false);
                console.log(res, "responseeee");
                console.log(limit, start, "Limittttt");
              }
            );
          }
        },
        { threshold: 1 }
      );
      if (observerTarget.current) {
        observer.observe(observerTarget.current);
      }
      return () => {
        if (observerTarget.current) {
          observer.unobserve(observerTarget.current);
        }
      };
    }
  }, [loadingMore, loadMore, limit, start]);
  return (
    <Row gutter={[10, 10]}>
      {courseData?.length > 0 ? (
        courseData?.map((course, index) => (
          <Col
            // xl={6}
            lg={8}
            md={12}
            key={course?.id}
            className="cursor-pointer"
            onClick={() =>
              navigate(`/courses/${course?.id}`, {
                state: { data: course },
              })
            }
          >
            <div
              className="bg-pureWhite rounded-xl p-3 flex flex-col justify-evenly h-full"
              ref={observerTarget}
            >
              <img
                className="rounded-lg h-[140px] w-full"
                src={course?.extraMetadata?.definition?.promoPhoto}
                alt={course?.name}
                width={241}
                height={140}
              />
              <div className="flex justify-between items-center mt-2">
                <p className="text-base w-[75%] text-black font-semibold">
                  {course?.name}
                </p>
                <p className="text-[10px] text-gray-400">
                  {/* {course?.updatedAt} */}
                  01:00 - 02:00
                </p>
              </div>
              <div className="flex justify-between items-center mt-2">
                <p className="text-sm w-[70%] text-black font-medium">
                  {course?.partners[0].name}
                </p>
                <p className="flex items-center gap-x-2 text-[10px] text-gray-400">
                  <span>
                    <ClockIcon />
                  </span>
                  {/* <span>{course?.duration}</span> */}
                  <span>2 Hour ago</span>
                </p>
              </div>

              <div className="flex justify-between items-center mt-2">
                <p className="flex items-center gap-x-2 text-[10px] text-gray-400">
                
                  {/* <span>{course?.location}</span> */}
               
                <p className=" text-[10px] text-gray-400">
                  {course?.difficultyLevel}
                </p>
                </p>
                <p className="flex items-center gap-x-2 text-[10px] text-gray-400">
                  {course?.contentType}
                </p>
              </div>
            </div>
          </Col>
        ))
      ) : courseData && courseData?.length == 0 && loading == true ? (
        <div className="w-full">
          <LoadingCom />
        </div>
      ) : courseData.length == 0 && loading == false ? (
        <div className="w-full">
          <h1 className="bg-signupTextBg inline-block ml-4 text-transparent bg-clip-text font-semibold text-lg w-full">
            No additional data to display.
          </h1>
        </div>
      ) : null}
    </Row>
  );
}
export default TypeOfCourses;
